import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1496.09903,0 L1098.78743,397.3116 L1250.33817,548.862342 L1388.92029,410.280228 L1388.92029,741.033828 C1388.92029,887.868706 1314.85977,939.100145 1172.95512,1024.30725 C1101.89561,1066.85721 1022.26181,1114.7661 960.205314,1186.03997 C898.148822,1114.7661 818.515016,1066.85721 747.45551,1024.30725 C605.550854,939.100145 531.490343,887.868706 531.490343,741.033828 L531.490343,410.280228 L670.072457,548.862342 L821.6232,397.3116 L424.3116,0 L27,397.3116 L178.550742,548.862342 L317.132857,410.280228 L317.132857,741.033828 C317.132857,1016.05448 494.513676,1122.59015 637.061404,1208.01161 C778.96606,1293.21871 853.026571,1344.45015 853.026571,1491.28503 L853.026571,1920 L1067.38406,1920 L1067.38406,1491.28503 C1067.38406,1344.45015 1141.44457,1293.21871 1283.34922,1208.01161 C1425.89695,1122.59015 1603.27777,1016.05448 1603.27777,741.033828 L1603.27777,410.280228 L1741.85989,548.862342 L1893.41063,397.3116 L1496.09903,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMasteryPathsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMasteryPathsSolid, _Component);

  var _super = _createSuper(IconMasteryPathsSolid);

  function IconMasteryPathsSolid() {
    _classCallCheck(this, IconMasteryPathsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMasteryPathsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMasteryPaths",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMasteryPathsSolid.displayName = "IconMasteryPathsSolid";
  return IconMasteryPathsSolid;
}(Component);

IconMasteryPathsSolid.glyphName = 'mastery-paths';
IconMasteryPathsSolid.variant = 'Solid';
IconMasteryPathsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMasteryPathsSolid;
export { IconMasteryPathsSolid };